import { useEffect } from "react";

export interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ children, onClose }) => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => document.body.classList.remove("overflow-hidden");
  }, []);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-100"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] min-h-[75px] overflow-y-auto relative p-8 font-montserrat">
        <button
          onClick={onClose}
          className="absolute top-[10px] right-[10px] cursor-pointer"
          aria-label="Close"
        >
          <svg
            width="53"
            height="53"
            viewBox="0 0 53 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="26.4336" cy="26.7715" r="26.1074" fill="#F1F1F1" />
            <path
              d="M26.4336 36.7734C31.9564 36.7734 36.4336 32.2963 36.4336 26.7734C36.4336 21.2506 31.9564 16.7734 26.4336 16.7734C20.9107 16.7734 16.4336 21.2506 16.4336 26.7734C16.4336 32.2963 20.9107 36.7734 26.4336 36.7734Z"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M23.4336 23.7734L29.4336 29.7734"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29.4336 23.7734L23.4336 29.7734"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
